// extracted by mini-css-extract-plugin
export default {"holder":"PromoBar_holder__4KfjY","-fixed-header":"PromoBar_-fixed-header__SOL2J","app-btn":"PromoBar_app-btn__x7A9+","close":"PromoBar_close__Obu6V"};